import { ConfigActions } from "../Constants/Constants";

/** returns config form title prefix */
export const getConfigFormTitle = (action) => {
  switch (action) {
    case ConfigActions.add:
      return "Add";
    case ConfigActions.edit:
      return "Update";
    case ConfigActions.view:
      return "View";
    default:
      return "";
  }
};

/**
 * @param {*} data : response from get all configs for given device model api
 * @returns Array of objects as required by device model config table
 */
export const convertDeviceModelConfigList = (data, modelId) => {
  const list = data.configs ? data.configs : [];
  return list.map((item) => {
    return {
      key: item.configid,
      configId: item.configid,
      deviceModelId: modelId,
      serviceId: item.serviceid,
      name: item.name,
      config: item.config,
      status: item.status,
    };
  });
};
/**
 * @param {*} data : device model config form submitted values
 * @param {*} action : action type: add or edit
 * @returns Object formatted as required by create or update api
 */
export const convertDeviceModelConfigFormToApi = (
  data,
  action = ConfigActions.add
) => {
  try {
    const returnData = {
      devicemodelid: data.modelId,
      serviceid: data.serviceId,
      config: JSON.parse(data.config),
    };

    if (action === ConfigActions.add) {
      returnData.name = data.name;
    }
    if (action === ConfigActions.edit) {
      returnData.configid = data.configId;
    }
    return returnData;
  } catch (error) {
    throw new Error("Error parsing submitted values");
  }
};

/**
 * @param {*} data : response from get all configs for given service api
 * @returns Array of objects as required by service config table
 */
export const convertServiceConfigList = (data) => {
  const list = data.configs ? data.configs : [];
  return list.map((item) => {
    return {
      key: item.configid,
      configId: item.configid,
      serviceId: item.serviceid,
      name: item.name,
      config: item.config,
      status: item.status,
    };
  });
};
/**
 * @param {*} data : service config form submitted values
 * @param {*} action : action type: add or edit
 * @returns Object formatted as required by create or update api
 */
export const convertServiceConfigFormToApi = (
  data,
  action = ConfigActions.add
) => {
  try {
    const returnData = {
      serviceid: data.serviceId,
      config: JSON.parse(data.config),
    };

    if (action === ConfigActions.add) {
      returnData.name = data.name;
    }
    if (action === ConfigActions.edit) {
      returnData.configid = data.configId;
    }
    return returnData;
  } catch (error) {
    throw new Error("Error parsing submitted values");
  }
};

/**
 * @param {*} data : response from get all configs for given service provider api
 * @returns Array of objects as required by service provider config table
 */
export const convertServiceProviderConfigList = (data) => {
  const list = data.configs ? data.configs : [];
  return list.map((item) => {
    return {
      key: item.configid,
      configId: item.configid,
      providerId: item.providerid,
      name: item.name,
      config: item.config,
      status: item.status,
    };
  });
};
/**
 * @param {*} data : service provider config form submitted values
 * @param {*} action : action type: add or edit
 * @returns Object formatted as required by create or update api
 */
export const convertServiceProviderConfigFormToApi = (
  data,
  action = ConfigActions.add
) => {
  try {
    const returnData = {
      providerid: data.providerId,
      config: JSON.parse(data.config),
    };

    if (action === ConfigActions.add) {
      returnData.name = data.name;
    }
    if (action === ConfigActions.edit) {
      returnData.configid = data.configId;
    }
    return returnData;
  } catch (error) {
    throw new Error("Error parsing submitted values");
  }
};

/**
 * @param {*} data : response from get all configs for given device api
 * @returns Array of objects as required by device config table
 */
export const convertDeviceConfigList = (data, modelId) => {
  const list = data.configs ? data.configs : [];
  return list.map((item) => {
    return {
      key: item.configid,
      configId: item.configid,
      providerId: item.providerid,
      serviceId: item.serviceid,
      deviceModelId: item.deviceModelId || modelId,
      deviceUuid: item.deviceuuid,
      groupId: item.groupid,
      name: item.name,
      config: item.config,
      status: item.status,
    };
  });
};
/**
 * @param {*} data : device config form submitted values
 * @param {*} action : action type: add or edit
 * @returns Object formatted as required by create or update api
 */
export const convertDeviceConfigFormToApi = (
  data,
  action = ConfigActions.add
) => {
  try {
    const returnData = {
      providerid: data.providerId,
      groupid: data.groupId,
      deviceuuid: data.deviceId,
      serviceid: data.serviceId,
      devicemodelid: data.deviceModelId,
      config: JSON.parse(data.config),
    };

    if (action === ConfigActions.add) {
      returnData.name = data.name;
    }
    if (action === ConfigActions.edit) {
      returnData.configid = data.configId;
    }
    return returnData;
  } catch (error) {
    throw new Error("Error parsing submitted values");
  }
};

/**
 * @param {*} data : response from get all configs for given group api
 * @returns Array of objects as required by group config table
 */
export const convertGroupConfigList = (data) => {
  const list = data.configs ? data.configs : [];
  return list.map((item) => {
    return {
      key: item.configid,
      configId: item.configid,
      providerId: item.providerid,
      serviceId: item.serviceid,
      deviceModelId: item.devicemodelid,
      groupId: item.groupid,
      name: item.name,
      config: item.config,
      status: item.status,
    };
  });
};
/**
 * @param {*} data : group config form submitted values
 * @param {*} action : action type: add or edit
 * @returns Object formatted as required by create or update api
 */
export const convertGroupConfigFormToApi = (
  data,
  action = ConfigActions.add
) => {
  try {
    const returnData = {
      providerid: data.providerId,
      groupid: data.groupId,
      serviceid: data.serviceId,
      devicemodelid: data.modelId,
      config: JSON.parse(data.config),
    };

    if (action === ConfigActions.add) {
      returnData.name = data.name;
    }
    if (action === ConfigActions.edit) {
      returnData.configid = data.configId;
    }
    return returnData;
  } catch (error) {
    throw new Error("Error parsing submitted values");
  }
};
